<template>
  <div id="tideng">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'TiDeng'
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/tideng/App.vue